/**
 * Utilitaires pour le formatage de texte
 */

/**
 * Convertit un texte en format de phrase normale
 * (Première lettre en majuscule, le reste en minuscule)
 * @param {string} text - Le texte à formater
 * @returns {string} - Le texte formaté
 */
export const toSentenceCase = (text) => {
  if (!text || typeof text !== 'string') return '';
  
  return text
    .toLowerCase() // Tout en minuscule d'abord
    .replace(/^\w/, (c) => c.toUpperCase()) // Première lettre en majuscule
    .replace(/\.\s+\w/g, (match) => match.toUpperCase()) // Première lettre après un point
    .replace(/!\s+\w/g, (match) => match.toUpperCase()) // Première lettre après un point d'exclamation
    .replace(/\?\s+\w/g, (match) => match.toUpperCase()); // Première lettre après un point d'interrogation
};

/**
 * Convertit un texte en format titre (première lettre de chaque mot importante en majuscule)
 * Exclut les articles, prépositions et conjonctions courantes
 * @param {string} text - Le texte à formater
 * @returns {string} - Le texte formaté en titre
 */
export const toTitleCase = (text) => {
  if (!text || typeof text !== 'string') return '';
  
  const smallWords = ['le', 'la', 'les', 'un', 'une', 'des', 'du', 'de', 'et', 'ou', 'à', 'au', 'aux', 'en', 'dans', 'sur', 'pour', 'par', 'avec', 'sans', 'sous', 'vers', 'chez'];
  
  return text
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      // Toujours capitaliser le premier et dernier mot
      if (index === 0 || index === text.split(' ').length - 1) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      // Ne pas capitaliser les petits mots
      if (smallWords.includes(word)) {
        return word;
      }
      // Capitaliser les autres mots
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

/**
 * Nettoie et formate un texte pour l'affichage
 * @param {string} text - Le texte à nettoyer
 * @returns {string} - Le texte nettoyé
 */
export const cleanText = (text) => {
  if (!text || typeof text !== 'string') return '';
  
  return text
    .trim() // Supprime les espaces en début/fin
    .replace(/\s+/g, ' ') // Remplace les espaces multiples par un seul
    .replace(/\n\s*\n/g, '\n\n'); // Normalise les sauts de ligne
};